var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6575 11.044C23.1046 11.044 22.6563 10.5958 22.6563 10.0429V3.45628L11.3885 14.7241C10.9975 15.1151 10.3636 15.1151 9.97261 14.7241C9.58163 14.3332 9.58163 13.6993 9.97261 13.3083L21.2507 2.03015H14.6436C14.0907 2.03015 13.6425 1.58192 13.6425 1.02899C13.6425 0.476067 14.0907 0.027832 14.6436 0.027832H23.6575C24.2104 0.027832 24.6587 0.476067 24.6587 1.02899V10.0429C24.6587 10.5958 24.2104 11.044 23.6575 11.044Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69068 6.00693C3.58483 6.00693 2.68836 6.9034 2.68836 8.00926V20.0232C2.68836 21.129 3.58483 22.0255 4.69068 22.0255H16.7046C17.8105 22.0255 18.7069 21.129 18.7069 20.0232V15.9389C18.7069 15.3859 19.1552 14.9377 19.7081 14.9377C20.261 14.9377 20.7093 15.3859 20.7093 15.9389V20.0232C20.7093 22.2349 18.9163 24.0278 16.7046 24.0278H4.69068C2.47898 24.0278 0.686035 22.2349 0.686035 20.0232V8.00926C0.686035 5.79755 2.47897 4.00461 4.69068 4.00461H8.77501C9.32794 4.00461 9.77617 4.45285 9.77617 5.00577C9.77617 5.5587 9.32794 6.00693 8.77501 6.00693H4.69068Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external_link.6de09a3f9f55746a436310f1f5742e2c.svg";
export { ForwardRef as ReactComponent };